import { Action } from '@anm/components/ActionsDropdown';
import { Item } from '@anm/components/ActionsDropdown/ActionItem';
import Tooltip from '@anm/components/Tooltip';
import { getLinkTarget, getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import { FC } from 'react';
import styled from 'styled-components';

import { ActionItemWrapper, ActionTooltip, ActionTooltipWrapper, RelativeWrapper } from '../streamVideo/Wrapper';
import { notStableTooltip } from '../NotStableTooltip';

const ItemWrarpper = styled.div`
  width: inherit;
`;

type TooltipContentProps = {
  publishUrl: string;
  isPublished: boolean;
};

type TooltipProps = TooltipContentProps & {
  action: Action;
  showBeta?: boolean;
  handler?: () => void;
  isNotStable?: boolean;
};

type AddToBrandActionProps = TooltipProps & {
  canEditBrand: boolean;
  showBeta?: boolean;
};

const StreamTooltipContent: FC<TooltipContentProps> = ({ isPublished, publishUrl }) => {
  const canNotEditBrandTooltip = (
    <>
      Please <a {...getUpgradeLinkProps()}>upgrade</a> to add it to brand.
    </>
  );

  const publishTooltip = (
    <>
      This video has not been published yet.{' '}
      <a href={publishUrl} target={getLinkTarget()}>
        Publish it in the editor
      </a>{' '}
      to add it to brand.
    </>
  );

  return <ActionTooltip>{isPublished ? canNotEditBrandTooltip : publishTooltip}</ActionTooltip>;
};

const AddToBrandActionActionWithTooltip: FC<TooltipProps> = ({
  action,
  isPublished,
  showBeta,
  publishUrl,
  handler,
  isNotStable
}) => (
  <ActionTooltipWrapper>
    <Tooltip
      delayShow={500}
      direction="top-center"
      renderContent={() =>
        isNotStable ? (
          <ActionTooltip>{notStableTooltip()}</ActionTooltip>
        ) : (
          <StreamTooltipContent {...{ isPublished, publishUrl }} />
        )
      }
    >
      <ActionItemWrapper>
        <Item {...action} {...{ handler, showBeta }} disabled={true} />
      </ActionItemWrapper>
    </Tooltip>
  </ActionTooltipWrapper>
);

const AddToBrandAction: FC<AddToBrandActionProps> = ({
  action,
  showBeta = false,
  handler,
  isPublished,
  canEditBrand,
  publishUrl,
  isNotStable
}) => (
  <RelativeWrapper as="div" {...action}>
    {canEditBrand && isPublished && !isNotStable ? (
      <ItemWrarpper onClick={handler}>
        <Item {...action} {...{ showBeta }} />
      </ItemWrarpper>
    ) : (
      <AddToBrandActionActionWithTooltip {...{ action, isNotStable, isPublished, showBeta, publishUrl }} />
    )}
  </RelativeWrapper>
);
export default AddToBrandAction;
